import { createComponentElement } from "@modules/content/creators/createComponentElement";
import { useComponentData } from "@modules/content/hooks/useComponentData";
import { ContentComponent } from "@modules/content/types";
import { useGetContentProgress } from "@modules/content/hooks/useGetContentProgress";
import { defaultPageSize } from "@modules/content/helpers/content";

import { useLockedContents } from "../hooks/useLockedContent";
import RepeatedJuzuList, {
  RepeatedJuzuListItemParameters,
  RepeatedJuzuListParameters,
} from "@components/layouts/content/RepeatedJuzuList";
import { useAppSelector } from "@lib/stores";
import _ from "lodash";
import { Server } from "@wajeez/wajeez.microservices";

const Component = createComponentElement((props, ref) => {
  const progresses = useAppSelector(({ content }) => content.progresses);

  const {
    getParameterValues,
    getItemsParameterValues,
    contents,
    content,
    isLoading,
    isLoadingMore,
    componentData,
    uniqueId,
    getMore,
    refresh,
    meta: { hasNextPage },
  } = useComponentData<
    RepeatedJuzuListParameters,
    RepeatedJuzuListItemParameters
  >(
    {
      ...props,
      pageNumber: 1,
      pageSize: 30,
    },
    ref
  );

  const progressesObj = _.reduce(
    progresses,
    function (
      obj: { [key: string]: Server.ContentEntityProgressOutput },
      param
    ) {
      if (param.contentEntityId) obj[param.contentEntityId] = param;

      return obj;
    },
    {}
  );

  const contentsWithProgress = contents?.map((c) => {
    return {
      ...c,
      progress: progressesObj[c.id || ""]?.currentProgress,
    };
  });

  const { title } = getParameterValues(["title"]);

  useGetContentProgress(
    Boolean(contents && contents.length > 0),
    contents ? contents.map((c) => c.id ?? "") : []
  );

  return (
    <RepeatedJuzuList
      contents={contentsWithProgress}
      isLoading={isLoading}
      items={getItemsParameterValues(["image"]).map((item) => {
        return {
          id: item.content.id,
          title: item.content.title,
          image: item.values.image,
        };
      })}
      onItemPress={props.onItemPress}
      parameterValues={{
        title: title || props.context?.title || "",
      }}
    />
  );
});

export const RepeatedJuzuListComponent: ContentComponent = {
  identifier: "COM:REPEATED:JUZU",
  component: Component,
};
